import { Injectable } from '@angular/core';

export interface Currency {
    name: string;
    symbol: string;
    code: string;
}

/*
 Available currencies definition
*/
export const Currencies: Currency[] = [
    {
        name: 'Česká koruna',
        symbol: 'Kč',
        code: 'CZK',
    },
    {
        name: 'Danish krone',
        symbol: 'kr',
        code: 'DKK',
    },
    {
        name: 'Euro',
        symbol: '€',
        code: 'EUR',
    },
    {
        name: 'Pound sterling',
        symbol: '£',
        code: 'GBP',
    },
];

@Injectable({
    providedIn: 'root',
})
export class CurrencyService {
    public static getCurrencies(): Currency[] {
        return Currencies;
    }
}
